@import "~/styles/variables";

.Empty {
  margin: $space-xl;
  max-width: 200px;
  text-align: center;
  color: var(--color-fg-muted);
  @include font-family("sans");
}

.Title {
  @include font-size("m");
  @include font-weight("semibold");
}

.Description {
  @include font-size("s");
  @include font-weight("semibold");
}
